import React from 'react'
import {useSearchParams} from 'react-router-dom'
import PageLayout from '../../../components/layout/PageLayout'
import PostDetailContainer from '../../../features/page/post/post/PostDetailContainer'

interface IProps {
    className?: string
}

const PostDetailPage: React.FC<IProps> = ({className}) => {
    const [searchParams] = useSearchParams(document.location.search)
    const postId = searchParams.get('id')

    return (
        <PageLayout title={'Post Detail'} className={`${className}`}>
            <PostDetailContainer postId={postId} />
        </PageLayout>
    )
}

export default PostDetailPage
